var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 68 68",
    viewBox: "0 0 68 68",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd542",
    d: "M59.09,60.45H8.91c-4.61,0-7.43-5.04-5.03-8.97l25.1-41.11c2.3-3.77,7.77-3.77,10.07,0l25.09,41.11 C66.53,55.41,63.7,60.45,59.09,60.45z",
    className: "colorffd542 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#070707",
    d: "M59.09,60.45H8.91c-4.28,0-7.03-4.34-5.47-8.11c0.85,2.1,2.88,3.69,5.47,3.69h50.18c2.59,0,4.62-1.6,5.47-3.7 C66.11,56.1,63.37,60.45,59.09,60.45z",
    opacity: 0.1,
    className: "color070707 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12.9,52.4c-0.3,0-0.53-0.13-0.67-0.39c-0.15-0.26-0.14-0.52,0.01-0.78l21.53-35.26 c0.15-0.25,0.37-0.37,0.66-0.37c0.29,0,0.51,0.12,0.66,0.37l21.52,35.26c0.16,0.26,0.16,0.52,0.01,0.78 c-0.15,0.26-0.37,0.39-0.67,0.39H12.9z",
    className: "colorfff svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#070707",
    d: "M56.62,52c-0.15,0.26-0.37,0.4-0.67,0.4H12.9c-0.3,0-0.53-0.14-0.67-0.4c-0.15-0.26-0.14-0.52,0.01-0.78 L13,49.97h38.16c0.3,0,0.53-0.13,0.67-0.39c0.15-0.26,0.14-0.53-0.01-0.78L32.77,17.59l1-1.63c0.15-0.24,0.37-0.37,0.66-0.37 c0.29,0,0.51,0.13,0.66,0.37L56.6,51.22C56.76,51.48,56.77,51.74,56.62,52z",
    opacity: 0.1,
    className: "color070707 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f34c6e",
    d: "M36.77,30.27l-1.07,8.69c-0.11,0.86-0.84,1.51-1.7,1.51l0,0c-0.87,0-1.6-0.65-1.7-1.51l-1.07-8.69 c-0.13-1.02,0.67-1.92,1.7-1.92h2.13C36.1,28.35,36.89,29.25,36.77,30.27z",
    className: "colorf34c6e svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 45.81,
    r: 1.91,
    fill: "#f34c6e",
    className: "colorf34c6e svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4fd2e4ae349a6e8660cf60ba136578ae.svg";
export { ForwardRef as ReactComponent };